import $ from "jquery";

if (document.querySelector(".quote-slider")) {

    // Initialize slider
    const quoteSliders = document.querySelectorAll(".quote-slider__slider");
    quoteSliders.forEach(slider => {
        
        $(slider).slick({
            arrows: false
        });

        // Add active state to slider dots
        const quoteSliderDots = slider.querySelectorAll(".quote-slider__dots span");
        quoteSliderDots.forEach(dot => {
            dot.onclick = e => {
                e.preventDefault();
                
                // Remove dot-active class from all dots
                quoteSliderDots.forEach(dot => dot.classList.remove("dot-active"));

                // Add dot-active class to all dots with data-slide equal to current slide
                slider.querySelectorAll(`.quote-slider__dots span[data-slide="${dot.dataset.slide}"]`).forEach(dot => {
                    dot.classList.add("dot-active");
                });

                // Go to corresponding slide
                $(slider).slick("slickGoTo", dot.dataset.slide);
            }
        });
    });

}